<div class="container-fluid">
  <div class="header-row">
    <div class="header-left">
      <div class="header-title">
        <span>
          {{tab_name}}
        </span>
        <button *ngIf="query" (click)="toggleQueryBox()" class="btn btn-link p-0 eye-btn">
          <i class="bi" [matTooltip]="showQueryBox ? 'Hide Query' : 'View Query'"
            [ngClass]="showQueryBox ? 'bi-eye-slash' : 'bi-eye'" matTooltipPosition="above">
          </i>
        </button>
      </div>

      <div *ngIf="showQueryBox && query" class="alert alert-info query-alert" role="alert">
        {{ query || 'No query found' }}
      </div>
    </div>
  </div>
  <div class="row">

    <div class="col m-10" style="margin:20px;">
      <p>
        Combining expert domain knowledge with machine learning, Quant IP created Quant IP Quality Score, the first
        indicator built on predictions of future patent success and therefore applicable from the first day of
        publication.

      </p>


      <div class="card patent_rating_card">
        <h3>Average Innovation Quality over Time (10y)</h3>

        <div class="spinner-border text-primary" role="status" *ngIf="showSpinner">
          <span class="visually-hidden">Loading...</span>
        </div>

        <div class="alert alert-danger" role="alert" *ngIf="innovation_quality_data_loading_failed">
          <p>
            Unfortunately, we weren't able to load the data for innovation quality over time. Please try again later, or
            for more assistance, please contact
            <a href="mailto:tech@quant-ip.com" style="color: blue">info&#64;quant-ip.com</a>.
          </p>
        </div>
      
        <div class="empty-state" *ngIf="showDataMissing">
          <div class="empty-state-content">
            <i class="bi bi-search empty-state-icon"></i>
            <h4>No Quality Metrics Available</h4>
            <p>There haven't been any inventions published in the last 10 years to generate quality metrics.
            </p>
          </div>
        </div>

        <div *ngIf="showinnovationQualityGraph" class="patent_rating_container">
          <plotly-plot class="patent_rating_plot" [data]="innovationQualityGraph.data"
            [layout]="innovationQualityGraph.layout"></plotly-plot>
          <!-- <img class="patent_rating" src={{patent_rating_image_url}} alt=""> -->
        </div>
      </div>
      <div style="margin:10px;">

        <p>
          Quant IP Quality Score combines various indicators into one quality assessment quantifying the quality of a
          company’s patents and the whole portfolio.




        </p>
        <p>
          <b> Grant Robustness:</b>
          The average probability for a patent to be granted in 5 major jurisdictions (USA, EU, China,
          Japan, Korea), evaluated at the time of publication of the patent application.
        </p>
        <p>
          <b> Market Potential:</b>
          The predicted number of markets the innovation will be filed in, 2 years after initial
          publication date.
        </p>
        <p>
          <b> Citation Potential:</b>
          The predicted number of forward citations an invention will have received 5 years after
          initial publication. Predicted scores are normalized within year and IPC batches, and aggregated into the
          final Quality Score.
        </p>
        <p>
          <!-- <b>
    Quant IP Patent Rating:
  </b> Based on the inventions of the company published in the last 3 years -->

        </p>


      </div>
    </div>

  </div>

</div>